import React,  { FunctionComponent, Component } from 'react';
import { Grid, Row, Column, Heading, cls } from '../../../packages/components';
import { LOGIN_CM_HEADER_BRASIL } from '../../utils/constants';
import Translator from '../../../requests/apa/Translator';
import Assets from '../../../requests/apa/Asset';
import './_styles.scss';

enum TypeLogin {
  CLARO = 'claro',
  NET = 'net',
  HDTV = 'hdtv'
}

enum Steps {
  STEP_MAIL = 'INSERT_MAIL',
  STEP_CODE = 'INSERT_CODE',
  STEP_PASSWORD = 'INSERT_PASSWORD'
}

interface IHeaderLoginLabelsProps {
    /**
     * * type register
     */
    typeLogin?: string;
        /**
     * * type step
     */
    step?: string;
}

export const HeaderLoginLabels: FunctionComponent<IHeaderLoginLabelsProps> = (props) => {
    let { typeLogin, step} = props;
    let headerLogo = Assets.get('login_music_title_icon_logoClaromusica') || '';
    let subTitle: string = '';
   
    switch (typeLogin) {
      case TypeLogin.CLARO:
        headerLogo =  Assets.get('login_music_title_icon_logoClarovideo') || '';
        subTitle =  Translator.get('login_music_access_description_label','Informe seu senha')
        break;
      case TypeLogin.NET:
        headerLogo = Assets.get('login_music_title_icon_logoNET') || '';
        subTitle = Translator.get('login_music_accessNET_description_label','Infome seu login no Minha Claro (username ou CPF)')
        break;
      case TypeLogin.HDTV:
        headerLogo = Assets.get('login_music_title_icon_logoHDTV') || '';
        subTitle = Translator.get('login_music_accessHDTV_description_label','Infome seu login no Minha Claro (username ou CPF)')
          break;
      default:
          break;
  }

    return (
      <Grid className={cls(`${LOGIN_CM_HEADER_BRASIL}-column-grid`)}>
        <Row>
          <Column lg={5} className={cls(`${LOGIN_CM_HEADER_BRASIL}-column-title-size`)}>
            <Heading size={1} className={cls(`${LOGIN_CM_HEADER_BRASIL}-title`)}>
              {Translator.get('login_music_accessNET_title_label','Fazer login')}
            </Heading>
          </Column>
          <Column lg={1} className={cls(`${LOGIN_CM_HEADER_BRASIL}-column-title-size-right`, `${LOGIN_HEADER_BRASIL}-column-pipe`)}>|</Column>
          <Column lg={6}>
            <img className={cls(`${LOGIN_CM_HEADER_BRASIL}-column-image`, `${LOGIN_CM_HEADER_BRASIL}-column-image-`+typeLogin)} src={headerLogo} alt="claroTv logo" />
          </Column>  
        </Row>
        <Row>
          <Column lg={8}>
            <Heading size={2} className={cls(`${LOGIN_CM_HEADER_BRASIL}-subtitle`)}>
              {step == Steps.STEP_MAIL ? subTitle 
                : Steps.STEP_PASSWORD ? Translator.get('login_music_password_description_label','')
                : Translator.get('login_music_validationCode_description_label', '')
              }
            </Heading>
          </Column>               
        </Row>
      </Grid>
    );
};




// WEBPACK FOOTER //
// ./src/authentication/LoginCM/HeaderBrasil/index.tsx